const $inject = [
  "$scope",
  "$uibModal",
  "MessageService",
  "clinic",
];

class ClinicController {
  constructor($scope, $uibModal, MessageService, clinic) {
    this.$scope = $scope;
    this.$uibModal = $uibModal;
    this.MessageService = MessageService;
    $scope.clinic = clinic;

    this.reset_api_key();
  }

  reset_api_key() {
    this.$scope.api_key = null;
  }

  copyApiKeyToClipboard() {
    let self = this;
    navigator.clipboard.writeText(this.$scope.api_key).then(
      value => self.MessageService.add(
        "success",
        "Copied the API key to the clipboard."
      ),
      reason => self.MessageService.add(
        "danger",
        "Could not copy the API key to the clipboard."
      )
    ).then(
      value => self.$scope.$apply(),
      reason => self.$scope.$apply()
    );
  }

  openApiKeyModal() {
    var self = this;

    var modal = this.$uibModal.open({
      animation: true,
      backdrop: true,
      templateUrl: "clinicApiKeyModal.html",
      controller: "ClinicApiKeyModalController",
      controllerAs: "ClinicApiKeyCtrl",
      resolve: {
        clinic: function () {
          return self.$scope.clinic;
        },
        reset_api_key: function () {
          return self.reset_api_key.bind(self);
        }
      },
    });

    modal.result.then(
      function (api_key) {
        self.$scope.api_key = api_key;
        self.$scope.timestamp = new Date();
      },
      function () {
      }
    );
  }
}

ClinicController.$inject = $inject;
export default ClinicController;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/admin/controllers/clinic.controller.js
 **/